// How long the stats job keeps reprocessing a result past trackingEndsAt so payouts driven by
// in-window clicks that get ingested late still attribute.
const OPPORTUNITY_PAYOUT_TRAILING_DAYS = 3;
const OPPORTUNITY_REPORTING_REFRESH_RETRY_HOURS = 7 * 24;

// One credit-approval buffer day plus the trailing payout window: the stats job stops touching a
// result this many days past its deadline, and the review lock below ends on the same day.
const STATS_FENCE_BUFFER_DAYS = 1 + OPPORTUNITY_PAYOUT_TRAILING_DAYS;

const isOpportunityResultFinalized = result => !!(result.isCompleted || result.Payout_id || result.ManagerPayout_id || result.earningsFinalizedAt);

// Explain why a result is protected from invalidation or completion reversal.
const getOpportunityReviewLockReason = (result, opportunity, now = new Date(), hasPaidPayout = false) => {
  if (!result) return null;
  const reason = 'This opportunity is finalized and its review window is closed. Submissions and completion credit can no longer be invalidated or removed.';
  if (result.earningsFinalizedAt) return reason;
  // Without an explicit review period, preserve the existing correction window even after completion.
  if (!Number(opportunity?.daysToReviewUponCompletion)) {
    if (!isOpportunityResultFinalized(result) && !hasPaidPayout) return null;
    const fenceEndsAt = opportunity?.trackingEndsAt && new Date(opportunity.trackingEndsAt);
    if (!fenceEndsAt || Number.isNaN(fenceEndsAt.getTime()) || hasPaidPayout) return reason;
    fenceEndsAt.setUTCDate(fenceEndsAt.getUTCDate() + STATS_FENCE_BUFFER_DAYS);
    fenceEndsAt.setUTCHours(23, 59, 59, 999);
    return now > fenceEndsAt ? reason : null;
  }
  const reviewEndsAt = result.reviewStart ? new Date(result.reviewStart) : null;
  if (result.isInReview && (!reviewEndsAt || Number.isNaN(reviewEndsAt.getTime()))) return reason;
  if (reviewEndsAt) reviewEndsAt.setUTCDate(reviewEndsAt.getUTCDate() + Number(opportunity?.daysToReviewUponCompletion || 0));
  // The stats job selects review rows through the UTC day containing deadline + the fence buffer.
  const fenceEndsAt = reviewEndsAt && new Date(reviewEndsAt);
  if (fenceEndsAt) {
    fenceEndsAt.setUTCDate(fenceEndsAt.getUTCDate() + STATS_FENCE_BUFFER_DAYS);
    fenceEndsAt.setUTCHours(23, 59, 59, 999);
  }
  const hasReviewExpired = !!result.isInReview && reviewEndsAt && now >= reviewEndsAt && now <= fenceEndsAt;
  if (!isOpportunityResultFinalized(result) && !hasReviewExpired) return null;
  return reason;
};

module.exports = { OPPORTUNITY_REPORTING_REFRESH_RETRY_HOURS, OPPORTUNITY_PAYOUT_TRAILING_DAYS, STATS_FENCE_BUFFER_DAYS, isOpportunityResultFinalized, getOpportunityReviewLockReason };
